import PageContainer from "@/components/base/PageContainer";

const STATS = [
  { value: "20+", label: "演示影视作品" },
  { value: "12+", label: "演示影视资讯" },
  { value: "16", label: "影视类型分类" },
  { value: "4", label: "地区维度筛选" },
];

const HIGHLIGHTS = [
  {
    icon: "ri-layout-grid-line",
    title: "多维分类检索",
    desc: "按类型、地区、年份自由筛选，快速定位想看的内容。",
  },
  {
    icon: "ri-star-smile-line",
    title: "精彩率评分",
    desc: "以评分与热门榜单辅助选片，减少纠结时间。",
  },
  {
    icon: "ri-newspaper-line",
    title: "行业资讯同步",
    desc: "新闻、评论、行业报道三线并行，掌握影视动态。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-50 border-y border-background-200">
      <PageContainer className="py-10 md:py-14">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-label mb-4">
              <i className="ri-information-line" />
              关于影视影院
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950 leading-tight">
              专业便捷的影视内容查询平台
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              影视影院以丰富的电影、电视剧资源展示及最新影视资讯为主题，面向喜欢追剧、观影和了解影视动态的普通大众及影视爱好者。用户可以快速获取热门及最新影视作品信息，查看影视简介与基本资料，并浏览相关影视资讯，方便选片与把握行业动态。
            </p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {STATS.map((stat) => (
                <div key={stat.label} className="p-3 rounded-lg bg-background-100 border border-background-200">
                  <p className="font-heading font-extrabold text-xl md:text-2xl text-primary-700">
                    {stat.value}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {HIGHLIGHTS.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200"
              >
                <span className="w-12 h-12 shrink-0 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <div>
                  <h3 className="font-heading font-bold text-base text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-8 text-xs text-foreground-400 text-center leading-relaxed">
          本站为纯前端演示站点，所有影视作品、评分、人物与资讯均为虚构演示数据，不代表任何真实作品；未接入真实播放、下载及数据接口。
        </p>
      </PageContainer>
    </section>
  );
}